import React, { useEffect, useState } from "react";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import {
  getAllFinacManagerAction,
  resetAuthError,
  resetAuthSuccess,
  resetFinacManagerList,
  resetSession,
  resetUserProfileAllData,
  userProfileAction,
} from "../../redux/auth";
import { LoginResponseType, UserProfileType } from "../../redux/auth/authTypes";
import {
  GetAllFinacUserPayloadType,
  GetUserProfilePayload,
} from "../../commonTypes/authTypes";
import {
  resetUsersProfileError,
  resetUsersProfileSuccess,
} from "../../redux/usersProfile";
import LoggedInUsersLeaveBalance from "../../components/MySpace/LoggedInUsersLeaveBalance";
import LoggedInUsersWFHBalance from "../../components/MySpace/LoggedInUsersWFHBalance";
import LoggedInUsersMissingTimeSheet from "../../components/MySpace/LoggedInUsersMissingTimeSheet";
import {
  addRegularizeAction,
  getSingleUserAttendanceReportAction,
  getTimeSheetUnfilledReportAction,
  resetSingleAttendaceReportList,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
  resetUnfilledTimesheetCount,
} from "../../redux/timeSheet";
import {
  calculatePreviousDate,
  currentDate,
  currentMonthNumber,
  currentYear,
  current_month_first_date,
  current_month_last_date,
  formatDate,
  reverseDate,
  reverseDateFormat,
} from "../../utils/commonFunctions";
import {
  AddRegularizePayloadType,
  GetMissingTimesheetSummaryReport,
  GetSingleUserAttendanceReportDataPayloadType,
} from "../../commonTypes/timeSheetTypes";
import OpenTimeSheetUnfilledDateModal from "../../components/TimeSheet/OpenTimeSheetUnfilledDateModal";
import LoggedInUsersProfile from "../../components/MySpace/LoggedInUsersProfile";
import LoggedInUsersScheduledJob from "../../components/MySpace/LoggedInUsersScheduledJob";
import LoggedInUsersCheckInCheckOutReport from "../../components/MySpace/LoggedInUsersCheckInCheckOutReport";
import {
  getMasterDataHolidayCalenderAction,
  resetHolidayCalenderList,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
} from "../../redux/masterData";
import { GetHolidayCalenderPayloadType } from "../../commonTypes/masterDataTypes";
import { HolidayCalenderListType } from "../../redux/masterData/masterTypes";
import LoggedInUsersHolidayCalendar from "../../components/MySpace/CheckinCheckOutAttendanceTable/LoggedInUsersHolidayCalendar";
import {
  getSchedulingCalendar,
  resetCalendarData,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../redux/scheduling";
import { CommonHeader, ErrorSuccessModal } from "../../components/commons";
import HolidayCalenderModalView from "../../components/MySpace/HolidayCalenderModalView";
import WorkAnniversaries from "../../components/MySpace/WorkAnniversaries";
import UpcomingBirthdays from "../../components/MySpace/UpcomingBirthdays";
import LeavePendingApproval from "../../components/MySpace/AllLeaves/manager/LeavePendingApproval";

import {
  getAttendanceAverageAction,
  getAverageJobRatingListAction,
  getMySpaceUpcomingBirthDayAction,
  getMySpaceWorkAnniversaryAction,
  getPeopleOnLeaveAction,
  resetAttendanceAverage,
  resetMySpaceWorkAnniversaryList,
  resetPeopleOnLeaveList,
  resetUpcomingBirthdayList,
  resetViewMyTeamMembersCount,
  resetViewMyTeamMembersData,
} from "../../redux/mySpace";
import {
  GetAttendanceAveragePayloadType,
  GetAverageJobRatingPayloadType,
  GetMySpacePeopleOnLeavePayloadType,
  GetMySpaceUpcomingEventsDataPayloadType,
} from "../../commonTypes/mySpaceType";
import {
  AverageJobRatingListDataType,
  PeopleOnLeaveListType,
  UpcomingBirthdayListType,
  WorkAnniversaryListType,
} from "../../redux/mySpace/mySpaceTypes";
import {
  getUpcomingListAction,
  resetUpcomingLeaveList,
} from "../../redux/stcoTools";
import { LeaveAndWFHListPayloadType } from "../../commonTypes/stcoToolsType";
import {
  LeaveStatus,
  WorkFromHomeStatus,
} from "../../redux/stcoTools/stcoToolsType";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import PeopleOnLeave from "../../components/MySpace/PeopleOnLeave";
import PeopleOnLeaveModal from "../../components/MySpace/PeopleOnLeaveModal";
import AttendanceDetails from "../../components/MySpace/AttendanceDetails";
import WFHPendingApproval from "../../components/MySpace/AllLeaves/manager/WFHPendingApproval";
import CheckInModule from "../../components/MySpace/CheckInModule";
import PEFormModule from "./PEFormModule";
import RegularizeModal from "../../components/MySpace/RegularizeModal";
import useDebounce from "../../customHooks/useDebounce";
import toast, { Toaster } from "react-hot-toast";
import MyJobRating from "./MyJobRating";

type AppProps = {
  loginData: LoginResponseType;
  token: string | null;
  timesheetMessage: string | null;
  dispatchUserProfileData: (data: GetUserProfilePayload) => void;
  userProfileAllData: UserProfileType;
  dispatchResetAuthError: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetUserProfileAllData: () => void;
  //timesheet
  unfilledTimesheetCount: string | number;
  dispatchResetTimeSheetReportSuccess: () => void;
  dispatchResetTimeSheetReportError: () => void;
  dispatchResetTimeSheetReportMessage: () => void;
  dispatchResetTimeSheetReportStatusCode: () => void;
  dispatchResetUnfilledTimeSheetReportTotalCount: () => void;
  dispatchGetTimeSheetUnfilledDatesReportAction: (
    data: GetMissingTimesheetSummaryReport
  ) => void;
  history: any;
  dispatchGetSingleAttendanceReportList: (
    data: GetSingleUserAttendanceReportDataPayloadType
  ) => void;
  dispatchResetSingleAttendanceReportList: () => void;
  attendanceReportList: any;

  // upcoming event
  mySpaceWorkAnniversaryList: WorkAnniversaryListType[] | [];
  upcomingBirthdayList: UpcomingBirthdayListType[] | [];
  upcomingBirthdayTotalCount: number;
  upcomingBirthDayFetching: boolean;
  workAnniversaryfetching: boolean;
  dispatchResetMySpaceWorkAnniversaryList: () => void;
  dispatchResetUpcomingBirthdayList: () => void;
  dispatchGetMySpaceWorkAnniversaryAction: (
    data: GetMySpaceUpcomingEventsDataPayloadType
  ) => void;
  dispatchGetMySpaceUpcomingBirthDayAction: (
    data: GetMySpaceUpcomingEventsDataPayloadType
  ) => void;

  ///calender
  dispatchResetMasterDataHolidayCalenderListing: () => void;
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => void;
  holidayCalenderList: HolidayCalenderListType[] | [];
  dispatchResetCalendarData: () => void;
  dispatchgetSchedulingCalendar: (data: any) => void;
  dispatchResetSession: () => void;
  approvedData: any;
  userFetching: boolean;
  timesheetFetching: boolean;
  SchedulingCalendarFetching: boolean;
  holidayFetching: boolean;
  masterSuccess: number | null;
  mySpaceSuccess: number | null;
  authSuccess: number | null;
  schedulingSuccess: number | null;
  timeSheetsuccess: number | null;
  authStatusCode: number | null;
  masterStatusCode: number | null;
  schedulingStatusCode: number | null;
  timeSheetStatusCode: number | null;
  authError: null | string;
  masterError: null | string;
  schedulingError: null | string;
  timeSheetError: null | string;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  dispatchUpcomingLeaveListAction: (data: LeaveAndWFHListPayloadType) => void;
  dispatchResetUpcomingLeaveAndWFHList: () => void;
  leaveStatus: LeaveStatus;
  workFromHomeStatus: WorkFromHomeStatus;
  finacManagerList: any;
  managerFetching: boolean;
  ///people on leave
  dispatchGetPeopleOnLeaveAction: (
    data: GetMySpacePeopleOnLeavePayloadType
  ) => void;
  peopleOnLeaveFetching: boolean;
  peopleOnLeaveData: PeopleOnLeaveListType[] | [];
  dispatchResetPeopleOnLeaveList: () => void;
  //attendanceAverage
  dispatchGetAttendanceAverage: (data: GetAttendanceAveragePayloadType) => void;
  dispatchResetAttendanceAverage: () => void;
  attendanceAverageFetching: boolean;
  attendanceAverage: number;
  performanceEvaluationFetching: boolean;
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchAddRegularizeAction: (data: AddRegularizePayloadType) => void;
  dispatchResetFinacManagerList: () => void;
  totalManagerCount: string | number;
  averageJobRatingList: AverageJobRatingListDataType[] | [];
  averageJobRatingCount: number;
  averageJobRatingFetching: boolean;
  dispatchGetAverageJobRatingListAction: (
    data: GetAverageJobRatingPayloadType
  ) => void;
  averageJobRatingData: number;
  // view my team members
  dispatchResetTeamMembersData: () => void;
  dispatchResetTeamMembersCount: () => void;
  fetchingStcoTools: boolean;
};

const MySpace = ({
  loginData,
  token,
  mySpaceSuccess,
  dispatchUserProfileData,
  userProfileAllData,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetUserProfileAllData,
  unfilledTimesheetCount,
  dispatchResetTimeSheetReportSuccess,
  dispatchResetTimeSheetReportError,
  dispatchResetTimeSheetReportMessage,
  dispatchResetTimeSheetReportStatusCode,
  dispatchResetUnfilledTimeSheetReportTotalCount,
  dispatchGetTimeSheetUnfilledDatesReportAction,
  history,
  timesheetMessage,
  dispatchResetSingleAttendanceReportList,
  dispatchGetSingleAttendanceReportList,
  attendanceReportList,
  dispatchResetMasterDataHolidayCalenderListing,
  dispatchGetMasterDataHolidayCalenderAction,
  holidayCalenderList,
  dispatchResetCalendarData,
  dispatchgetSchedulingCalendar,
  approvedData,
  userFetching,
  timesheetFetching,
  SchedulingCalendarFetching,
  holidayFetching,
  masterSuccess,
  authSuccess,
  schedulingSuccess,
  timeSheetsuccess,
  authStatusCode,
  masterStatusCode,
  schedulingStatusCode,
  timeSheetStatusCode,
  authError,
  masterError,
  schedulingError,
  timeSheetError,
  mySpaceWorkAnniversaryList,
  upcomingBirthdayList,
  upcomingBirthdayTotalCount,
  upcomingBirthDayFetching,
  workAnniversaryfetching,
  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterError,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  dispatchGetMySpaceWorkAnniversaryAction,
  dispatchResetMySpaceWorkAnniversaryList,
  dispatchGetMySpaceUpcomingBirthDayAction,
  dispatchResetUpcomingBirthdayList,
  dispatchUpcomingLeaveListAction,
  dispatchResetUpcomingLeaveAndWFHList,
  leaveStatus,
  dispatchGetPeopleOnLeaveAction,
  peopleOnLeaveFetching,
  peopleOnLeaveData,
  dispatchResetPeopleOnLeaveList,
  dispatchGetAttendanceAverage,
  dispatchResetAttendanceAverage,
  attendanceAverageFetching,
  attendanceAverage,
  workFromHomeStatus,
  managerFetching,
  finacManagerList,
  totalManagerCount,
  dispatchGetAllFinacManagerAction,
  dispatchResetFinacManagerList,
  dispatchAddRegularizeAction,
  averageJobRatingList,
  averageJobRatingFetching,
  averageJobRatingCount,
  dispatchGetAverageJobRatingListAction,
  averageJobRatingData,
  performanceEvaluationFetching,
  dispatchResetTeamMembersData,
  dispatchResetTeamMembersCount,
  fetchingStcoTools,
  // dispatchViewMyTeamMembersData,
}: AppProps) => {
  const [allPeopleOnLeaveData, setAllPeopleOnLeaveData] = useState(false);
  const [isLeaveApprovalPresent, setIsLeaveApprovalPresent] = useMenuCheck();
  const [isWFHApprovalPresent, setIsWFHApprovalPresent] = useMenuCheck();
  const [isHolidayCalendarPresent, setIsHolidayCalendarPresent] =
    useMenuCheck();
  const [isPeopleOnLeavePresent, setIsPeopleOnLeavePresent] = useMenuCheck();
  const [isApplyWFHApplyPresent, setIsApplyWFHApplyPresent] = useMenuCheck();
  const [isMyCheckInsPresent, setIsMyCheckInsPresent] = useMenuCheck("");
  const [isMyPEFormPresent, setIsMyPEFormPresent] = useMenuCheck("");
  const [isMyAverageJobRatingPresent, setIsMyAverageJobRatingPresent] =
    useMenuCheck("average");

  const [showTimeSheetUnfilledDate, setShowTimeSheetUnfilledDate] =
    useState(false);
  const [viewAllHolidays, setViewAllHolidays] = useState(false);
  const [showRegularize, setShowRegularize] = useState(false);
  const [regularizeData, setRegularizeData] = useState(null);

  const [holidayData, setHoliDayData] = useState<
    HolidayCalenderListType[] | []
  >([]);
  const [finalManagerList, setFinalManagerList] = useState<any>([]);
  const [managerText, setManagerText] = useState<string>("");
  const [managerLimit, setManagerLimit] = useState<number>(20);
  const [managerOffset, setManagerOffset] = useState<number>(0);

  const [unfilledTimesheetCountData, setUnfilledTimesheetCountData] = useState<
    string | number
  >(0);
  
  const currentMonthFirstDate = current_month_first_date();
  const currentMonthLastDate = current_month_last_date();
  let isDefaultEmployee = userProfileAllData?.job_details?.find(
    (jobDetails: any) => jobDetails?.is_default === true
  );
  const isDefaultEmployeeStartDate: any =
    isDefaultEmployee?.job_info?.start_date;
  let isCurrentMonthDate = false;
  if (isDefaultEmployeeStartDate) {
    const startDateObj: any = new Date(isDefaultEmployeeStartDate);
    if (
      startDateObj.getMonth() + 1 === currentMonthNumber() &&
      startDateObj.getFullYear() === currentYear()
    ) {
      isCurrentMonthDate = true;
    }
  }
  useEffect(() => {
    setIsLeaveApprovalPresent("Leave Pending Approval", "menu");
    setIsWFHApprovalPresent("WFH Pending Approval", "menu");
    setIsHolidayCalendarPresent("My Space Holiday Calendar", "menu");
    setIsPeopleOnLeavePresent("People On Leave", "menu");
    setIsApplyWFHApplyPresent("Apply WFH Balance", "menu");
    setIsMyCheckInsPresent("My Check-Ins", "menu");
    setIsMyPEFormPresent("My PE Form", "menu");
    setIsMyAverageJobRatingPresent("Average Job Rating", "menu");

    ///profile
    dispatchResetUserProfileAllData();
    dispatchResetAuthError();
    dispatchResetAuthSuccess();

    ////timesheet
    dispatchResetTimeSheetReportSuccess();
    dispatchResetTimeSheetReportError();
    dispatchResetTimeSheetReportMessage();
    dispatchResetTimeSheetReportStatusCode();
    dispatchResetUnfilledTimeSheetReportTotalCount();

    ///holiday
    setHoliDayData([]);
    dispatchResetMasterDataHolidayCalenderListing();
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetMasterStatusCode();

    //scheduling
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
    // upcoming event
    dispatchResetMySpaceWorkAnniversaryList();

    ///leave
    dispatchResetUpcomingLeaveAndWFHList();

    dispatchResetPeopleOnLeaveList();

    // attendanceAverage
    dispatchResetAttendanceAverage();
    dispatchResetFinacManagerList();

    // viewTeamMembersData
    dispatchResetTeamMembersData();
    dispatchResetTeamMembersCount();
  }, []);

  //Manager List

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: "manager",
        status: 1,
        search_term: managerText,
      };
      if (managerOffset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData);
      }
    }
  }, [managerOffset]);
  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: managerOffset,
      limit: managerLimit,
      user_type: "manager",
      status: 1,
      search_term: managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };

  useDebounce(
    () => {
      if (managerText) {
        fetchNewManagerData(managerText);
      } else {
        const finalData = {
          token,
          offset: managerOffset,
          limit: managerLimit,
          user_type: "manager",
          status: 1,
          search_term: managerText,
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [managerText]
  );

  useEffect(() => {
    const finalManagerData = finacManagerList?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        } `,
        image: user?.profile_pic?.file_url,
      };
    });
    if (managerOffset > 0) {
      setFinalManagerList([...finalManagerList, ...finalManagerData]);
    } else {
      setFinalManagerList(finalManagerData);
    }
  }, [finacManagerList]);

  useEffect(() => {
    if (!showTimeSheetUnfilledDate) {
      setUnfilledTimesheetCountData(unfilledTimesheetCount);
    }
  }, [unfilledTimesheetCount]);

  ///profile

  useEffect(() => {
    if (token) {
      if (loginData.user_id) {
        let final_data = {
          token,
          user_id: loginData.user_id,
        };
        dispatchUserProfileData(final_data);
      }
      let finalData = {
        token,
        user_type: "employee",
        status: "1",
      };
      dispatchUpcomingLeaveListAction(finalData);
    }
  }, []);

  //  time sheet
  useEffect(() => {
    if (!showTimeSheetUnfilledDate) {
      if (currentMonthFirstDate && token) {
        let final_data = {
          token,
          // start_date: currentMonthFirstDate,
          start_date: isCurrentMonthDate
            ? formatDate(isDefaultEmployeeStartDate)
            : currentMonthFirstDate,
          end_date: reverseDate(currentDate()),
        };
        dispatchGetTimeSheetUnfilledDatesReportAction(final_data);
      }
    }
  }, [showTimeSheetUnfilledDate, isDefaultEmployeeStartDate]);

  ///AttendanceReport check in check out
  const previousDate = calculatePreviousDate(
    new Date().toISOString().split("T")[0],
    30
  );
  useEffect(() => {
    dispatchResetSingleAttendanceReportList();
    if (token && loginData.user_id) {
      let finalData = {
        token,
        start_date: reverseDate(previousDate),
        end_date: reverseDate(currentDate()),
        user_id: loginData?.user_id.toString(),
        // limit: 7,
      };
      dispatchGetSingleAttendanceReportList(finalData);
    }
  }, []);

  ///people on leave
  useEffect(() => {
    if (token) {
      let finalData = {
        token,
      };

      dispatchGetPeopleOnLeaveAction(finalData);
    }
  }, []);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
      };

      isMyAverageJobRatingPresent &&
        dispatchGetAverageJobRatingListAction(finalData);
    }
  }, [isMyAverageJobRatingPresent]);
  ///attendanceAverage

  useEffect(() => {
    if (token && loginData?.user_id) {
      let finalData = {
        token,
        user_id: loginData?.user_id,
        start_date: current_month_first_date(),
        end_date: reverseDateFormat(currentDate()),
      };
      dispatchGetAttendanceAverage(finalData);
    }
  }, []);

  ///holiday calender
  useEffect(() => {
    dispatchResetMasterDataHolidayCalenderListing();
    let finalData: GetHolidayCalenderPayloadType = {
      token,
      start_date: reverseDate(currentDate()),
      end_date: `31-12-${currentYear()}`,
      country: "India",
      limit: 5,
      sort_by: "date",
      sort_by_value: "asc",
      user_id_filter:loginData?.user_id,
      branch_id_filter:userProfileAllData?.hr_settings?.work_details
      ?.user_branch?._id
    };
    dispatchGetMasterDataHolidayCalenderAction(finalData);
  }, []);

  const handleOpenTimeSheetUnfilledDate = () => {
    setShowTimeSheetUnfilledDate(!showTimeSheetUnfilledDate);
  };

  const handleToggleHolidaysModal = () => {
    setViewAllHolidays(!viewAllHolidays);
  };

  // upcoming events
  useEffect(() => {
    dispatchResetMySpaceWorkAnniversaryList();
    let finalData: GetMySpaceUpcomingEventsDataPayloadType = {
      token,
      event_type: "work_anniversary",
      limit: 5,
    };
    dispatchGetMySpaceWorkAnniversaryAction(finalData);
  }, []);

  useEffect(() => {
    dispatchResetUpcomingBirthdayList();
    let finalData: GetMySpaceUpcomingEventsDataPayloadType = {
      token,
      event_type: "birthday",
      limit: 5,
    };
    dispatchGetMySpaceUpcomingBirthDayAction(finalData);
  }, []);

  //// holiday calendar view all data
  useEffect(() => {
    if (viewAllHolidays) {
      dispatchResetMasterDataHolidayCalenderListing();
      let finalData: GetHolidayCalenderPayloadType = {
        token,
        start_date: `01-01-${currentYear()}`,
        end_date: `31-12-${currentYear()}`,
        country: "India",
        sort_by: "date",
        sort_by_value: "asc",
        user_id_filter:loginData?.user_id,
        branch_id_filter:userProfileAllData?.hr_settings?.work_details
        ?.user_branch?._id
      };
      dispatchGetMasterDataHolidayCalenderAction(finalData);
    } else {
      dispatchResetMasterDataHolidayCalenderListing();
      let finalData: GetHolidayCalenderPayloadType = {
        token,
        start_date: reverseDate(currentDate()),
        end_date: `31-12-${currentYear()}`,
        country: "India",
        limit: 5,
        sort_by: "date",
        sort_by_value: "asc",
        user_id_filter:loginData?.user_id,
        branch_id_filter:userProfileAllData?.hr_settings?.work_details
        ?.user_branch?._id
      };
      dispatchGetMasterDataHolidayCalenderAction(finalData);
    }
  }, [viewAllHolidays]);

  useEffect(() => {
    if (holidayCalenderList?.length && !viewAllHolidays) {
      setHoliDayData(holidayCalenderList);
    } else if (holidayCalenderList?.length === 0 && !viewAllHolidays) {
      setHoliDayData([]);
    }
  }, [holidayCalenderList]);

  // scheduling
  useEffect(() => {
    if (loginData?.user_id) {
      dispatchResetCalendarData();
      let finaData = {
        token,
        user_id: loginData?.user_id,
        // startDate: "01-07-2023",
        // endDate: currentDate(),
        startDate: currentDate(),
        endDate: reverseDate(currentMonthLastDate),
        schedule_status: 3,
      };

      dispatchgetSchedulingCalendar(finaData);
    }
  }, []);
  useEffect(() => {
    if (
      timesheetMessage === "Attendance regularize record sent successfully."
    ) {
      toast.success("Attendance regularize record sent successfully.", {
        duration: 2000,
      });
      dispatchResetTimeSheetReportStatusCode();
      dispatchResetTimeSheetReportSuccess();
      dispatchResetTimeSheetReportMessage();
      if (token && loginData.user_id) {
        let finalData = {
          token,
          start_date: reverseDate(previousDate),
          end_date: reverseDate(currentDate()),
          user_id: loginData?.user_id.toString(),
        };
        dispatchGetSingleAttendanceReportList(finalData);
      }
    }
  }, [timesheetMessage]);
  const handleTogglePeopleOnLeaveModal = () => {
    setAllPeopleOnLeaveData(!allPeopleOnLeaveData);
  };

  let firstName = userProfileAllData?.user_details?.basic_details?.first_name;
  let lastName = userProfileAllData?.user_details?.basic_details?.last_name;

  const handleErrorModal = () => {
    if (authSuccess === 0) {
      if (authStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!authError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={authStatusCode}
          />
        );
      } else if (!!authError && authStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!authError}
            title="Error"
            message={authError}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      } else if (!!masterError && masterStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!masterError}
            title="Error"
            message={masterError}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
            }}
          />
        );
      } else if (!!schedulingError && schedulingStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!schedulingError}
            title="Error"
            message={schedulingError}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
            }}
          />
        );
      } else if (!!timeSheetError && timeSheetStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!timeSheetError}
            title="Error"
            message={timeSheetError}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetReportError();
            }}
          />
        );
      }
    }

    return false;
  };

  const handleToggleSendRegularizeApprovalData = (data: any) => {
    setRegularizeData(data);
    setShowRegularize(!showRegularize);
  };

  const handleToggleSendRegularizeApproval = () => {
    setShowRegularize(!showRegularize);
  };

  const handleSubmitRegularizeInformation = (data: any) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchAddRegularizeAction(finalData);
    }
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="My Space" />
      </div>

      <div className="w-100 d-flex mt-4" style={{ gap: "2%" }}>
        <div style={{ width: "68%" }}>
          <div className="row col-md-12 w-100 p-4 boxs">
            <LoggedInUsersProfile
              userProfileAllData={userProfileAllData}
              history={history}
              userId={loginData?.user_id}
              fetching={userFetching}
              token={token}
              dispatchResetTeamMembersData={dispatchResetTeamMembersData}
              dispatchResetTeamMembersCount=
              {dispatchResetTeamMembersCount}
            />
          </div>

          <div className="mt-3 w-100" style={{ display: "flex", gap: "10px" }}>
            <LoggedInUsersLeaveBalance
              history={history}
              userProfileAllData={userProfileAllData}
              leaveStatus={leaveStatus}
              fetching={fetchingStcoTools || userFetching }
            />
            <LoggedInUsersWFHBalance
              history={history}
              userProfileAllData={userProfileAllData}
              workFromHomeStatus={workFromHomeStatus}
              isApplyWFHApplyPresent={isApplyWFHApplyPresent}
              fetching={fetchingStcoTools || userFetching}

            />
            {/* <LoggedInUsersMissingTimeSheet
              handleOpenTimeSheetUnfilledDate={handleOpenTimeSheetUnfilledDate}
              unfilledTimesheetCount={unfilledTimesheetCountData}
              fetching={timesheetFetching}
            /> */}
          </div>
          {/* ///manager side */}

          {/* <div className="mt-3 w-100" style={{ display: "flex", gap: "10px" }}>
            <LeavePendingApproval
              history={history}
              id={userProfileAllData?.user_id}
              isLeaveApprovalPresent={isLeaveApprovalPresent}
            />
            <WFHPendingApproval
              history={history}
              id={userProfileAllData?.user_id}
              isWFHApprovalPresent={isWFHApprovalPresent}
            />
          </div> */}

          {/* /////manager end */}
          <div
            className="mt-3 w-100"
            style={{
              display: "grid",
              gridTemplateColumns: "33% 32% 33%",
              gap: "1%",
            }}
          >
            <LoggedInUsersScheduledJob
              data={approvedData}
              history={history}
              userId={loginData?.user_id}
              name={firstName + " " + lastName}
              fetching={SchedulingCalendarFetching}
            />
            <LoggedInUsersMissingTimeSheet
              handleOpenTimeSheetUnfilledDate={handleOpenTimeSheetUnfilledDate}
              unfilledTimesheetCount={unfilledTimesheetCountData}
              fetching={timesheetFetching}
            />
            {/* <LoggedInUsersCurrentlyResponsibleJobs /> */}
            <AttendanceDetails
              attendanceAverage={attendanceAverage}
              fetching={attendanceAverageFetching}
            />
          </div>
          <div
            className="mt-3 w-100"
            style={{
              display: "grid",
              gridTemplateColumns: "33% 32% 33%",
              gap: "1%",
            }}
          >
            {isMyCheckInsPresent && <CheckInModule history={history} />}

            {isMyPEFormPresent && (
              <PEFormModule
                history={history}
                performanceEvaluationFetching={performanceEvaluationFetching}
              />
            )}

            {isMyAverageJobRatingPresent && (
              <MyJobRating
                history={history}
                averageJobRatingFetching={averageJobRatingFetching}
                averageJobRatingData={averageJobRatingData}
                averageJobRatingList={averageJobRatingList}
                averageJobRatingCount={averageJobRatingCount}
                mySpaceSuccess={mySpaceSuccess}
              />
            )}
          </div>

          <LoggedInUsersCheckInCheckOutReport
            data={attendanceReportList}
            history={history}
            fetching={timesheetFetching}
            userProfileAllData={userProfileAllData}
            handleToggleSendRegularizeApprovalData={
              handleToggleSendRegularizeApprovalData
            }
          />
        </div>
        <div
          style={{
            width: "29%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <div className="m-0 w-100">
            <LeavePendingApproval
              history={history}
              id={userProfileAllData?.user_id}
              isLeaveApprovalPresent={isLeaveApprovalPresent}
              // isWFHApprovalPresent={isWFHApprovalPresent}
            />
            <WFHPendingApproval
              history={history}
              id={userProfileAllData?.user_id}
              isWFHApprovalPresent={isWFHApprovalPresent}
            />
          </div>

          {isHolidayCalendarPresent ? (
            <div
              style={{
                height: holidayData?.length <= 3 ? "300px" : "320px",
                margin: 0,
                width: "100%",
              }}
            >
              <LoggedInUsersHolidayCalendar
                handleToggleHolidaysModal={handleToggleHolidaysModal}
                data={holidayData}
                fetching={holidayFetching}
              />
            </div>
          ) : (
            ""
          )}
          {isPeopleOnLeavePresent && (
            <div className="m-0 w-100">
              <PeopleOnLeave
                data={peopleOnLeaveData}
                handleTogglePeopleOnLeaveModal={handleTogglePeopleOnLeaveModal}
                fetching={peopleOnLeaveFetching}
              />
            </div>
          )}
          <WorkAnniversaries
            data={mySpaceWorkAnniversaryList}
            fetching={workAnniversaryfetching}
          />
          <UpcomingBirthdays
            data={upcomingBirthdayList}
            fetching={upcomingBirthDayFetching}
          />
        </div>
      </div>
      {showTimeSheetUnfilledDate && (
        <OpenTimeSheetUnfilledDateModal
          isOpen={showTimeSheetUnfilledDate}
          toggle={() => {
            dispatchResetTimeSheetReportStatusCode();
            dispatchResetTimeSheetReportSuccess();
            dispatchResetTimeSheetReportMessage();
            handleOpenTimeSheetUnfilledDate();
          }}
        />
      )}
      {viewAllHolidays && (
        <HolidayCalenderModalView
          data={holidayCalenderList}
          toggle={handleToggleHolidaysModal}
          isOpen={viewAllHolidays}
        />
      )}
      {allPeopleOnLeaveData && (
        <PeopleOnLeaveModal
          data={peopleOnLeaveData}
          toggle={handleTogglePeopleOnLeaveModal}
          isOpen={allPeopleOnLeaveData}
        />
      )}
      {showRegularize && (
        <RegularizeModal
          data={regularizeData}
          toggle={handleToggleSendRegularizeApproval}
          isOpen={showRegularize}
          finalManagerList={finalManagerList?.filter(
            (user: any) => user?.value !== loginData?.user_id
          )}
          managerFetching={managerFetching}
          setManagerOffset={setManagerOffset}
          setManagerText={setManagerText}
          managerLimit={managerLimit}
          handleSubmit={handleSubmitRegularizeInformation}
        />
      )}
      <Toaster />
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  userProfileAllData: state.auth.userProfileAllData,
  loginData: state.auth.loginData,
  token: state.auth.token,
  unfilledTimesheetCount: state.timeSheet.unfilledTimesheetCount,
  attendanceReportList: state.timeSheet.attendanceReportList,
  holidayCalenderList: state.masterData.holidayCalenderList,
  approvedData: state.scheduling.calendarData,
  mySpaceWorkAnniversaryList: state.mySpace.mySpaceWorkAnniversaryList,
  workAnniversaryTotalCount: state.mySpace.workAnniversaryTotalCount,
  upcomingBirthdayList: state.mySpace.upcomingBirthdayList,
  upcomingBirthdayTotalCount: state.mySpace.upcomingBirthdayTotalCount,
  upcomingBirthDayFetching: state.mySpace.upcomingBirthDayFetching,
  workAnniversaryfetching: state.mySpace.workAnniversaryfetching,
  performanceEvaluationFetching: state.mySpace.performanceEvaluationFetching,
  managerFetching: state.auth.managerFetching,

  // message
  timesheetMessage: state.timeSheet.message,

  ///fetching
  userFetching: state.auth.fetching,
  timesheetFetching: state.timeSheet.fetching,
  SchedulingCalendarFetching: state.scheduling.fetching,
  holidayFetching: state.masterData.fetching,

  ///success
  authSuccess: state.auth.success,
  masterSuccess: state.masterData.success,
  schedulingSuccess: state.scheduling.success,
  timeSheetsuccess: state.timeSheet.success,

  ///status code
  authStatusCode: state.auth.statusCode,
  masterStatusCode: state.masterData.statusCode,
  schedulingStatusCode: state.scheduling.statusCode,
  timeSheetStatusCode: state.timeSheet.statusCode,

  ///// error
  authError: state.auth.error,
  masterError: state.masterData.error,
  schedulingError: state.scheduling.error,
  timeSheetError: state.timeSheet.error,

  ///leave
  leaveStatus: state.stcoTools.leaveStatus,
  workFromHomeStatus: state.stcoTools.workFromHomeStatus,
  fetchingStcoTools: state.stcoTools.fetching,
  //people on leave
  peopleOnLeaveFetching: state.mySpace.peopleOnLeaveFetching,
  peopleOnLeaveData: state.mySpace.peopleOnLeaveData,

  // attendanceAverage
  attendanceAverageFetching: state.mySpace.attendanceAverageFetching,
  attendanceAverage: state.mySpace.attendanceAverage,
  finacManagerList: state.auth.finacManagerList,
  totalManagerCount: state.auth.totalManagerCount,
  // averageJobRating
  averageJobRatingList: state.mySpace.averageJobRatingList,
  averageJobRatingFetching: state.mySpace.averageJobRatingFetching,
  averageJobRatingCount: state.mySpace.averageJobRatingCount,
  averageJobRatingData: state.mySpace.averageJobRatingData,
  mySpaceSuccess: state.mySpace.success,
});
const mapDispatchToProps = (dispatch: any) => ({
  ////profile
  dispatchUserProfileData: (data: GetUserProfilePayload) =>
    dispatch(userProfileAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetUsersProfileError: () => dispatch(resetUsersProfileError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetUsersProfileSuccess: () => dispatch(resetUsersProfileSuccess()),
  dispatchResetUserProfileAllData: () => dispatch(resetUserProfileAllData()),
  // time sheet
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetReportSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetReportError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetReportMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetReportStatusCode: () =>
    dispatch(resetTimeSheetStatusCode()),
  dispatchResetUnfilledTimeSheetReportTotalCount: () =>
    dispatch(resetUnfilledTimesheetCount()),
  dispatchGetTimeSheetUnfilledDatesReportAction: (
    data: GetMissingTimesheetSummaryReport
  ) => dispatch(getTimeSheetUnfilledReportAction(data)),

  //check in
  dispatchGetSingleAttendanceReportList: (
    data: GetSingleUserAttendanceReportDataPayloadType
  ) => dispatch(getSingleUserAttendanceReportAction(data)),
  dispatchResetSingleAttendanceReportList: () =>
    dispatch(resetSingleAttendaceReportList()),

  ///holiday calender
  dispatchResetMasterDataHolidayCalenderListing: () =>
    dispatch(resetHolidayCalenderList()),
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => dispatch(getMasterDataHolidayCalenderAction(data)),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),

  ///scheduling calender
  dispatchResetCalendarData: () => dispatch(resetCalendarData()),
  dispatchgetSchedulingCalendar: (data: any) =>
    dispatch(getSchedulingCalendar(data)),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
  // upcoming events
  dispatchGetMySpaceWorkAnniversaryAction: (
    data: GetMySpaceUpcomingEventsDataPayloadType
  ) => dispatch(getMySpaceWorkAnniversaryAction(data)),
  dispatchResetMySpaceWorkAnniversaryList: () => {
    dispatch(resetMySpaceWorkAnniversaryList());
  },
  dispatchGetMySpaceUpcomingBirthDayAction: (
    data: GetMySpaceUpcomingEventsDataPayloadType
  ) => {
    dispatch(getMySpaceUpcomingBirthDayAction(data));
  },
  dispatchResetUpcomingBirthdayList: () => {
    dispatch(resetUpcomingBirthdayList());
  },

  /// All leaves

  dispatchUpcomingLeaveListAction: (data: LeaveAndWFHListPayloadType) =>
    dispatch(getUpcomingListAction(data)),
  dispatchResetUpcomingLeaveAndWFHList: () =>
    dispatch(resetUpcomingLeaveList()),
  ////people on leave
  dispatchGetPeopleOnLeaveAction: (data: GetMySpacePeopleOnLeavePayloadType) =>
    dispatch(getPeopleOnLeaveAction(data)),
  dispatchResetPeopleOnLeaveList: () => {
    dispatch(resetPeopleOnLeaveList());
  },
  /// attendance average
  dispatchGetAttendanceAverage: (data: GetAttendanceAveragePayloadType) => {
    dispatch(getAttendanceAverageAction(data));
  },
  dispatchResetAttendanceAverage: () => dispatch(resetAttendanceAverage()),
  dispatchResetFinacManagerList: () => dispatch(resetFinacManagerList()),
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),
  dispatchAddRegularizeAction: (data: AddRegularizePayloadType) =>
    dispatch(addRegularizeAction(data)),
  dispatchGetAverageJobRatingListAction: (
    data: GetAverageJobRatingPayloadType
  ) => dispatch(getAverageJobRatingListAction(data)),

  // // view my team members
  dispatchResetTeamMembersData: () => dispatch(resetViewMyTeamMembersData()),
  dispatchResetTeamMembersCount: () => dispatch(resetViewMyTeamMembersCount())
});

export default connect(mapStateToProps, mapDispatchToProps)(MySpace);
